<template>
  <div>
    <el-button class="guide-btn" type="primary" :disabled="isConnect" :loading="loading" @click="connectMetaMask()">
      <img class="mm-logo" src="@/assets/logo/mm-logo.png" />
      {{ btnText }}
    </el-button>
  </div>
</template>

<script>
import MetaMaskOnboarding from "@metamask/onboarding";
import metaMask from "@/layout/components/metaMaskInit/metaMask.js";
export default {
  name: 'mmLogin',
  data() {
    return {
      btnText: 'Connect Wallet',
      isInstall: true,
      isConnect: false,
      loading: false,
      account: '',
      chainId: '',
    }
  },
  created() {
    this.init()

    ethereum.autoRefreshOnNetworkChange = false
    // CheckAccount();
    //监听钱包切换
    ethereum.on('accountsChanged', function (accounts) {
      // window.location.reload()
      console.log('accountsChanged', accounts)
    })
    //监听链网络改变
    ethereum.on('chainChanged', (chainId) => {
      console.log('chainChanged', chainId)
      // if(chainId != process.env.VUE_APP_CHAINID){
      //   this.$message.error("connection failed! ");
      // }
      // sessionStorage.setItem("TREASURE_CHAINID",chainId);
      // if(this.$store.getters.metaMaskObj.stopRefreshJoinNet){
      //   this.$store.commit("app/SET_MATEMASK",{ chainId: chainId });
      // if(chainId != process.env.VUE_APP_CHAINID){
      //   this.$message.error("connection failed! ");
      // }
      // }else{
      //   window.location.reload();
      // }
    })
  },
  methods: {
    init() {
      this.isInstall = metaMask.isMetaMaskInstalled()
      if (this.isInstall) {
        this.btnText = 'Connect Wallet'
      } else {
        this.btnText = 'Install MetaMask'
      }
    },
    connectMetaMask(type) {
      if (this.isConnect) {
        return
      }
      if (!this.isInstall) {
        // window.open("https://metamask.io/download/")
        // this.loading = true
        this.btnText = 'Onboarding in progress'
        const onboarding = new MetaMaskOnboarding()
        onboarding.startOnboarding()
      } else {
        this.loading = false
        this.btnText = 'Connect Wallet'
        this.joinNet().then(() => {
          console.log('joinNet')
          this.onClickConnect()
        })
      }
    },
    async onClickConnect() {
      try {
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        this.loading = true
        await ethereum.request({ method: 'eth_requestAccounts' })
        const accounts = await ethereum.request({ method: 'eth_accounts' })
        console.log('accountsxx', accounts)
        if (!accounts[0]) {
          this.$message.error('Not able to get accounts')
        } else {
          console.log('accountsxxxx', accounts)
          this.account = accounts[0]
          this.$emit('success', this.account)
        }

      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async joinNet() {
      try {
        this.loading = true;
        // 确保 RPC URLs 是正确解析的数组
        let rpcUrls;
        try {
          rpcUrls = JSON.parse(process.env.VUE_APP_RPC_URLS);
          console.log('process.env.VUE_APP_RPC_URLS', rpcUrls);
        } catch (e) {
          console.error('RPC URLs parsing error:', e);
          rpcUrls = [process.env.VUE_APP_RPC_URLS]; // If parsing fails, try using as a single URL
        }
        
        // 确保 chainId 是十六进制格式，以 0x 开头
        const chainId = process.env.VUE_APP_CHAINID.startsWith('0x') 
          ? process.env.VUE_APP_CHAINID 
          : '0x' + parseInt(process.env.VUE_APP_CHAINID).toString(16);
        
        console.log('Using chainId:', chainId);
        
        // 先尝试切换到目标链
        try {
          await ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId }],
          });
          console.log('Successfully switched to target chain');
          this.loading = false;
          return;
        } catch (switchError) {
          // 如果链不存在（4902错误），则添加链
          if (switchError.code === 4902) {
            console.log('Chain does not exist, attempting to add new chain');
            let res = await ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [
                {
                  chainId: chainId,
                  chainName: 'Treasurenet',
                  rpcUrls: Array.isArray(rpcUrls) ? rpcUrls : [rpcUrls],
                  nativeCurrency: {
                    name: 'UNIT',
                    symbol: 'UNIT',
                    decimals: 18,
                  },
                },
              ],
            });
            this.loading = false;
            return res;
          } else {
            console.error('切换链失败:', switchError);
            this.loading = false;
            throw switchError;
          }
        }
      } catch (error) {
        this.loading = false;
        console.error('MetaMask connection error:', error);
        this.$message.error(error.message || 'Network connection failed');
      }
    },
    loginResult(res) {
      if (res === 'success') {
        this.btnText = 'Connected'
        this.isConnect = true
      } else {
        this.btnText = 'Connect Wallet'
        this.isConnect = false
      }
      this.loading = false

    },
    async getChainId() {
      let res = await ethereum.request({ method: 'eth_chainId' })
      this.chainId = res
      console.log(res)

    }
  }
}
</script>

<style lang="scss" scoped>
.mm-logo {
  margin-right: 0.1rem;
}
</style>